import script from "./Sub6.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sub6.vue?vue&type=script&setup=true&lang=ts"

import "./Sub6.vue?vue&type=style&index=0&id=1bf6c734&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf6c734"]])

export default __exports__